// extracted by mini-css-extract-plugin
export default {"tableLayout":"templatesTable_tableLayout__bmgZ-"};